import React from "react";

import FadeInSection from "../FadeIn/FadeIn";

import "./ContentBlock.css";

const contentBlock = (props) => {
  let classes = "ContentBlock ";
  if (props.color) {
    classes += props.color;
  }
  if (props.reverse) {
    classes += " reverse";
  }
  return (
    <div className={classes}>
      {props.img_src ? (
        <FadeInSection>
          <img src={props.img_src} alt={props.img_alt} />
        </FadeInSection>
      ) : null}

      {props.children}
    </div>
  );
};

export default contentBlock;
